import React, { useEffect, useState } from 'react';
import './Header.css';

const Header = () => {
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const nav = document.querySelector('.nav-menu');
    const links = nav ? nav.querySelectorAll('a[href^="#"]') : [];

    // Scroll spy functionality
    const updateActiveSection = () => {
      const sections = ['home', 'sectors', 'services', 'project-section', 'registration-section', 'why-fatl-section'];
      const headerHeight = 80;
      
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= headerHeight + 100) {
            setActiveSection(sections[i]);
            break;
          }
        }
      }
    };

    const smoothScroll = (event) => {
      const anchor = event.currentTarget;
      const hash = anchor.getAttribute('href');
      if (!hash || hash === '#') return;
      const target = document.querySelector(hash);
      if (!target) return;
      event.preventDefault();

      const startY = window.pageYOffset;
      const targetRect = target.getBoundingClientRect();
      const headerHeight = 80; // updated header height
      const destinationY = startY + targetRect.top - headerHeight;

      const duration = 900; // slower smooth scroll (ms)
      const startTime = performance.now();

      const easeInOutCubic = (t) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

      const step = (now) => {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const eased = easeInOutCubic(progress);
        const currentY = startY + (destinationY - startY) * eased;
        window.scrollTo(0, currentY);
        if (progress < 1) requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    };

    // Add scroll listener for scroll spy
    window.addEventListener('scroll', updateActiveSection);
    window.addEventListener('resize', updateActiveSection);
    
    // Initial check
    updateActiveSection();

    links.forEach((a) => a.addEventListener('click', smoothScroll));

    return () => {
      window.removeEventListener('scroll', updateActiveSection);
      window.removeEventListener('resize', updateActiveSection);
      links.forEach((a) => a.removeEventListener('click', smoothScroll));
    };
  }, []);
  return (
    <header className="header">
      <div className="logo-section">
        <div className="logo-icon">
          <img src="/logo.png" alt="Fatl Logo" />
        </div>
        <div className="logo-text">منصة فتل</div>
      </div>

      <button className="mobile-menu-toggle" id="mobile-menu-toggle">☰</button>

      <nav>
        <ul className="nav-menu">
          <li><a href="#home" className={activeSection === 'home' ? 'active' : ''}>الرئيسية</a></li>
          <li><a href="#sectors" className={activeSection === 'sectors' ? 'active' : ''}>القطاعات</a></li>
          <li><a href="#services" className={activeSection === 'services' ? 'active' : ''}>الخدمات</a></li>
          <li><a href="#project-section" className={activeSection === 'project-section' ? 'active' : ''}>المشاريع</a></li>
          <li><a href="#registration-section" className={activeSection === 'registration-section' ? 'active' : ''}>التسجيل</a></li>
          <li><a href="#why-fatl-section" className={activeSection === 'why-fatl-section' ? 'active' : ''}>لماذا فتل</a></li>
        </ul>
      </nav>

      <div className="header-buttons">
        <a href="#" className="btn btn-primary">تسجيل جديد</a>
        <a href="#" className="btn btn-secondary">تسجيل دخول</a>
      </div>
    </header>
  );
};

export default Header;


